// pages/sections/PeJobLink.js
// "Open in PE" link for a job row — opens the job in Practice Engine in a new tab.
import React from 'react';

export default function PeJobLink({ jobIdx }) {
  if (!jobIdx) return null;
  return (
    <a className="rt-pe-link" target="_blank" rel="noopener noreferrer"
       title="Open this job in Practice Engine (new tab)"
       href={`https://bmss.pehosted.com/pe/Job/Job/${jobIdx}?panel=0`}>
      Open in PE
    </a>
  );
}
